/**
 * main.tsx — React entry. Boots <App/> into #app.
 *
 * The app is browser-first: connection is handled by the Connectivity wizard
 * (it probes its own origin's backend), so there is no build-time
 * auto-connect pre-seeding here.
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import { patchFetchWithCredentials } from './license/patchFetch';
import './style.css';

// Before anything issues a request: cookies (the license-acceptance cookie)
// must ride every API call. See patchFetch.ts.
patchFetchWithCredentials();

const el = document.getElementById('app');
if (!el) throw new Error('#app not found');
createRoot(el).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
